import '/assets/styles/pages/web-landing.scss';

import config from '@wearetla/tla-essentials-tools/config';

// Partials
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Btn from '/views/partials/btn';

// Context & Utils
import { useApplication } from '/utilities/application';
import { useTranslation } from '/utilities/i18n';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';
import image_app_btn_apple_tr from '/assets/images/partials/app-links/btn-app-apple-tr.svg';
import image_app_btn_apple_en from '/assets/images/partials/app-links/btn-app-apple-en.svg';
import image_app_btn_google_tr from '/assets/images/partials/app-links/btn-app-google-tr.svg';
import image_app_btn_google_en from '/assets/images/partials/app-links/btn-app-google-en.svg';

const appBtnImages = {
	tr: { apple: image_app_btn_apple_tr, google: image_app_btn_google_tr },
	en: { apple: image_app_btn_apple_en, google: image_app_btn_google_en },
};

const WebLanding = () => {
	const { isApplication } = useApplication();
	const { t, language } = useTranslation();
	const appBtns = appBtnImages[language] ?? appBtnImages.tr;

	return (
		<>
			<Img src={image_logo} lazy={false} className="landing-logo" alt="IF Sokak" />

			<strong className="landing-message">
				{t('IF Sokak uygulamamızı kullanarak şubelerimizde kolayca sipariş verebilirsin.')}
			</strong>

			<ul className="landing-links">
				{!!config?.nativeApp?.appStoreLink && (
					<li className="links-link android">
						<Btn
							raw
							tag="link"
							target="_blank"
							rel="noopener noreferrer"
							className="link-btn block black rounded"
							href={config.nativeApp.appStoreLink}
						>
							<Img alt="Google Play Store" src={appBtns.apple} />
						</Btn>
					</li>
				)}
				{!!config?.nativeApp?.playStoreLink && (
					<li className="links-link ios">
						<Btn
							raw
							tag="link"
							target="_blank"
							rel="noopener noreferrer"
							className="link-btn block black rounded"
							href={config.nativeApp.playStoreLink}
						>
							<Img alt="App Store" src={appBtns.google} />
						</Btn>
					</li>
				)}
			</ul>

			{!isApplication && (
				<Link className="landing-redirectlink hyperlink" href="https://ifsokak.com/" raw>
					{t('IF Sokak Sitesine Dön')}
				</Link>
			)}
		</>
	);
};

export default WebLanding;
